import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { UPDATE_BENEFIT_GROUP, UPDATE_BENEFIT_GROUP_SUCCESS, UPDATE_BENEFIT_GROUP_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* updateBenefitGroup({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/benefitGroups`,
      method: 'PUT',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload.data,
    });

    if (response.status === 200) {
      cogoToast.success(`Benefit group updated successfully!`);
      yield put({
        type: UPDATE_BENEFIT_GROUP_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: UPDATE_BENEFIT_GROUP_ERROR,
        payload: response?.response?.data,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_BENEFIT_GROUP_ERROR, payload: error });
  }
}

export function* watchUpdateBenefitGroup() {
  yield takeEvery(UPDATE_BENEFIT_GROUP, updateBenefitGroup);
}

function* updateBenefitGroupSaga() {
  yield all([fork(watchUpdateBenefitGroup)]);
}

export default updateBenefitGroupSaga;
